import React, { Component } from 'react';
import { AbstractIcon } from './AbstractIcon';
import { AbstractIconDefaultProps, AbstractIconPropTypes } from './utils';

export class PhoneIcon extends Component {
    static defaultProps = AbstractIconDefaultProps;
    static propTypes = AbstractIconPropTypes;

    render() {
        const props = this.props;

        return (
            <AbstractIcon viewBox="0 0 24 24" {...props}>
                <path d="M10.75 6.26367H13.25M16 21.2637H8C6.895 21.2637 6 20.3687 6 19.2637V5.26367C6 4.15867 6.895 3.26367 8 3.26367H16C17.105 3.26367 18 4.15867 18 5.26367V19.2637C18 20.3687 17.105 21.2637 16 21.2637Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
                <path d="M12.01 17.2637L12.005 17.2687L12 17.2637" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
            </AbstractIcon>
        );
    }
}
